import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CardEditComponent } from 'src/common/components/card-edit/card-edit.component';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { Tools } from 'src/common/services/tools';
import { MandateService } from 'src/services/mandate/mandate.service';

@Component({
  selector: 'app-mandate-edit',
  templateUrl: './mandate-edit.component.html',
  styleUrls: ['./mandate-edit.component.scss']
})
export class MandateEditComponent extends CardEditComponent {

  public tools = new Tools();
  
  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: MandateService,
    protected router: Router,
    public backURL: BackurlService,
  ) {
    super(_cd, setting, db, router, backURL);
  }

  isDateAvailable(): boolean {
    return this.item.values.dateAvailable &&
    this.tools.getMTime(this.item.values.dateAvailable) !== this.item.values.dateStart?.getTime();
  }

}
